import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../services/dataService.service';

@Component({
  selector: 'app-casewidget',
  templateUrl: './casewidget.component.html',
  styleUrls: ['./casewidget.component.scss'],
})
export class CasewidgetComponent implements OnInit {

    static componentName = 'CasewidgetComponent';
    @Input()initFrom: any;

    cases: any;
    limit: any = 3;
    maxNumPosts: any;

    constructor(
        private dataService: DataService,
    ) {}

    getPosts(): void {
        this.dataService.getPosts('cases', false, this.limit, this.initFrom.post_id)
            .subscribe(res => this.convertPostsObject(res));
    }

    getMaxNumPosts(): void {
        this.dataService.getPosts('cases', false)
            .subscribe(res => this.maxNumPosts = Object.keys(res).length);
    }

    convertPostsObject(res): void {
        this.cases = Object.keys(res).map(function(resNamedIndex) {
            return res[resNamedIndex];
        });

        if (document.querySelectorAll('a.case-more').length) {
            document.querySelectorAll('a.case-more')[0].classList.remove('loading');
        }
    }

    getMoreCases() {
        document.querySelectorAll('a.case-more')[0].classList.add('loading');
        this.limit += 3;
        this.getPosts();
        if (this.limit >= this.maxNumPosts) {
            document.querySelectorAll('a.case-more')[0].remove();
        }
    }

    ngOnInit() {
        this.getPosts();
        this.getMaxNumPosts();
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/casewidget/casewidget.component.ts